import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "manage-members-container" }
const _hoisted_2 = { class: "current-members my-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-2xl font-semibold mb-6" }, "Mevcut Üyeler", -1)
const _hoisted_4 = { class: "member-list text-2xl space-y-2" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "add-members" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "text-2xl font-semibold mt-12 mb-4" }, "Yeni Üye Ekle", -1)
const _hoisted_10 = { class: "flex gap-4" }
const _hoisted_11 = ["disabled"]

import { ref, onMounted, computed } from 'vue'
import firebase from "@/firebase"
import VueMultiselect from 'vue-multiselect'
import type { AICollabMember } from "@/types"
import { assignProjectToUser } from "@/composables/aiChatFunctions"
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'manageProjectMembers',
  setup(__props) {

const store = useStore()
const selectedProject = computed(() => store.getters['ai/selectedProject'])

const isLoadingUsers = ref(false)
const users = ref<AICollabMember[]>([])
const selectedUsers = ref<AICollabMember[]>([])

const getUsers = async () => {
  isLoadingUsers.value = true
  const db = firebase.firestore().collection("team")
  const snapshot = await db.get()
  
  const newUsers = []
  snapshot.docs.forEach((doc) => {
    const firstName = doc.data().name.first
    const lastName = doc.data().name.last
    newUsers.push({
      id: doc.id,
      firstName: firstName,
      lastName: lastName,
      fullName: `${firstName} ${lastName}`
    })
  })
  
  users.value = newUsers
  isLoadingUsers.value = false
}

const nonAddedUsers = computed(() => {
  return users.value.filter((user) => {
    return !selectedProject.value.members.some((member) => member.id === user.id)
  })
})

const removeMember = async (member: AICollabMember) => {
  try {
    await store.dispatch('ai/removeProjectMember', member)
  } catch (error) {
    console.error('Error removing member:', error)
  }
}

const addMembers = async () => {
  try {
    const newMembers = selectedUsers.value.map(user => ({
      id: user.id,
      name: user.fullName
    }))
    
    await store.dispatch('ai/addProjectMembers', newMembers)
    selectedUsers.value = []

    // Assign project to each new user
    newMembers.forEach(async (member) => {
      await assignProjectToUser(selectedProject.value.id, member.id)
    })
    
  } catch (error) {
    console.error('Error adding members:', error)
  }
}

onMounted(async () => {
  await getUsers()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedProject.value.members, (member) => {
          return (_openBlock(), _createElementBlock("div", {
            key: member.id,
            class: "member-item flex items-center justify-between p-2 bg-gray-50 rounded"
          }, [
            _createElementVNode("span", null, _toDisplayString(member.name), 1),
            _createElementVNode("button", {
              onClick: ($event: any) => (removeMember(member)),
              class: "text-red-500 text-2xl hover:text-red-700"
            }, _hoisted_7, 8, _hoisted_5)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_unref(VueMultiselect), {
          modelValue: selectedUsers.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedUsers).value = $event)),
          options: nonAddedUsers.value,
          multiple: true,
          "close-on-select": false,
          "clear-on-select": false,
          "preserve-search": true,
          placeholder: "Kullanıcıları Seçin",
          label: "fullName",
          "track-by": "id",
          loading: isLoadingUsers.value,
          class: "flex-1"
        }, null, 8, ["modelValue", "options", "loading"]),
        _createElementVNode("button", {
          onClick: addMembers,
          class: "px-4 py-2 bg-blue-500 cursor-pointer text-white rounded text-2xl hover:bg-blue-600",
          disabled: !selectedUsers.value.length
        }, " Ekle ", 8, _hoisted_11)
      ])
    ])
  ]))
}
}

})